import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CARER_ROLE,
  ORGANISATION_ROLES,
  COORDINATOR_ROLE,
  FAMILY_ROLE,
  ADMIN_ROLE,
  ORGANISATION_ADMIN_ROLE
} from '@careapp/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';

@Component({
  selector: 'sd-invite',
  templateUrl: 'invite.component.html',
  styleUrls: ['invite.component.scss']
})
export class InviteComponent implements OnInit, OnDestroy {
  defRoles = ORGANISATION_ROLES;
  adminRoles = [ADMIN_ROLE, ORGANISATION_ADMIN_ROLE];
  coordinatorRole = [COORDINATOR_ROLE];
  nonadminRoles = [COORDINATOR_ROLE, CARER_ROLE, FAMILY_ROLE];
  error: Observable<string>;
  loading: Observable<boolean>;
  sent: Observable<boolean>;
  roleConfig = {
    property: 'role',
    header: 'Role',
    default: CARER_ROLE,
    role: true
  };

  preview = [
    {
      property: 'firstName',
      header: 'First Name'
    },
    {
      property: 'lastName',
      header: 'Last Name'
    },
    {
      property: 'email',
      unique: true,
      header: 'Email'
    },
    this.roleConfig
  ];

  file: any;
  fileProgress: Observable<number>;
  fileSuccess: Observable<boolean>;
  fileError: Observable<string>;

  mode: 'single' | 'bulk';

  subscriptions = new Array<Subscription>();

  constructor(public store: Store<any>, public route: ActivatedRoute) {
    this.mode = route.snapshot.params.mode || 'single';
  }

  ngOnInit() {
    this.error = this.store.select(selectors.invite.getError);
    this.loading = this.store.select(selectors.invite.getLoading);
    this.sent = this.store.select(selectors.invite.getSent);
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  invite(payload: any) {
    this.store.dispatch(new actions.RequestInvitationSendAction(payload));
  }

  reset() {
    this.file = undefined;
    this.store.dispatch(new actions.RequestInvitationResetAction());
    this.fileProgress = this.fileError = undefined;
  }

  importEvent(payload: any) {
    this.store.dispatch(actions.Staff.RequestBulkImport(payload));
  }
}
